import React from "react";
import { bannerImg, profileBgRed, profileBgBlue } from "../../assets/index";

const RightBanner = () => {
  return (
    <div className="w-full lgl:w-1/2 flex justify-center items-center relative">
      <img
        className="w-[250px] lgl:w-[450px] z-10 grayscale"
        src={bannerImg}
        alt="bannerImg"
      />
      <img
        src={profileBgBlue}
        alt="bgBanner"
        className="absolute lgl:w-[450px] w-[250px] mb-10 dark:hidden block"
      />
      <img
        src={profileBgRed}
        alt="bgBanner"
        className="absolute lgl:w-[450px] w-[250px] mb-10 hidden dark:block"
      />
    </div>
  );
};

export default RightBanner;
// profileBgRed,
// profileBgBlue,
